import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom, Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class MapsService {
    private _timeValuesCache: Array<string> | null = null;

    public constructor(private readonly _http: HttpClient) {}

    public async getTimeValues(): Promise<Array<string>> {
        if (this._timeValuesCache) {
            return this._timeValuesCache;
        }

        const timeValuesObservable: Observable<Array<string>> = this._http.get<Array<string>>(
            `${environment.apiUrl}/api/maps/GetTimeValues`
        );
        this._timeValuesCache = await firstValueFrom<Array<string>>(timeValuesObservable);
        return this._timeValuesCache;
    }

    public async getPreviousTimeValue(timeValue: string): Promise<string> {
        const previousTimeValueObservable: Observable<string> = this._http.get<string>(
            `${environment.apiUrl}/api/Maps/GetPreviousTimeValue/${timeValue}`
        );
        return firstValueFrom<string>(previousTimeValueObservable);
    }

    public clearCache(): void {
        this._timeValuesCache = null;
    }
}
